var _path, _circle, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgReportGroup = function SvgReportGroup(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4091 3.45138C23.9901 2.0548 21.0099 2.0548 18.5909 3.45138L6.22591 10.5903C3.80695 11.9869 2.31682 14.5679 2.31682 17.3611V31.6389C2.31682 34.4321 3.80695 37.0131 6.22591 38.4097L18.5909 45.5486C21.0099 46.9452 23.9901 46.9452 26.4091 45.5486L38.7741 38.4097C41.193 37.0131 42.6832 34.4321 42.6832 31.6389V17.3611C42.6832 14.5679 41.193 11.9869 38.7741 10.5903L26.4091 3.45138Z",
    fill: "white",
    stroke: "#F85963",
    strokeWidth: 3.12727
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 33.4583,
    r: 1.79167,
    fill: "#F85963"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0265 14.6288C18.9681 14.1622 19.332 13.75 19.8023 13.75H25.1977C25.6679 13.75 26.0318 14.1622 25.9734 14.6288L24.3772 27.3985C24.3283 27.7897 23.9957 28.0833 23.6015 28.0833H21.3985C21.0042 28.0833 20.6716 27.7897 20.6227 27.3985L19.0265 14.6288Z",
    fill: "#F85963"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReportGroup.236129f7.svg";
export { ForwardRef as ReactComponent };